//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import moment from 'moment-timezone';

import { localDateToPst } from '@instagram-account/date-range-helper';
import Interval from '@models/Interval';
import { IUnisonDateRange } from '@models/UnisonTypes';

// TODO: Consider migrating these to `Interval.ts` as well?
export default {
  pastDays: (numDays: number): Interval => {
    const end = moment().add(1, 'days').startOf('day');
    const start = moment().subtract(numDays, 'days');
    return Interval.fromMoments(start, end);
  },

  shortenInterval: (intervalString: string, amount: number, takeFromStart: boolean): Interval => {
    const [ start, end ] = intervalString.split('/');
    if (takeFromStart) {
      return Interval.fromMoments(
        moment(start).add(amount, 'days').startOf('day'),
        moment(end).startOf('day'),
      );
    } else {
      return Interval.fromMoments(
        moment(start).startOf('day'),
        moment(end).subtract(amount, 'days').startOf('day'),
      );
    }
  },

  fromDateRange: (dateRange: IUnisonDateRange, offset = 0, includeMillis = false): Interval => {
    const { startDate, endDate } = dateRange;
    const end = moment(localDateToPst(endDate)).add(1, 'days').startOf('day');
    const start = moment(localDateToPst(startDate)).subtract(offset, 'days');
    return Interval.fromMoments(start, end, includeMillis);
  },
};
